var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZengoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1445,
    height: 480,
    viewBox: "0 0 1445 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9863 169.407C24.9863 118.855 24.9863 93.5791 34.8244 74.2708C43.4782 57.2867 57.2867 43.4782 74.2708 34.8244C93.5791 24.9863 118.855 24.9863 169.407 24.9863H286.593C337.145 24.9863 362.421 24.9863 381.729 34.8244C398.713 43.4782 412.522 57.2867 421.176 74.2708C431.014 93.5791 431.014 118.855 431.014 169.407V286.593C431.014 337.145 431.014 362.421 421.176 381.729C412.522 398.713 398.713 412.522 381.729 421.176C362.421 431.014 337.145 431.014 286.593 431.014H169.407C118.855 431.014 93.5791 431.014 74.2708 421.176C57.2867 412.522 43.4782 398.713 34.8244 381.729C24.9863 362.421 24.9863 337.145 24.9863 286.593V169.407Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.809 214.879C209.544 211.71 212.767 216.939 207.995 223.069C195.727 238.826 176.732 272.097 200.693 286.934C211.407 293.57 227.418 288.704 240.864 284.235L243.02 283.516C246.573 282.329 249.908 281.218 252.869 280.418C271.884 275.282 291.946 270.39 311.627 274.553C334.236 279.333 349.57 302.004 346.582 325.048C343.616 347.915 323.219 364.389 300.444 364.389H161.487C134.512 364.925 115.798 345.345 113.81 322.167C113.467 318.179 113.588 314.097 114.207 310.013C118.247 283.441 133.323 261.852 151.916 243.661C163.913 231.923 185.527 219.85 201.487 214.978C201.593 214.947 201.704 214.921 201.809 214.879ZM294.513 90.8179C321.488 90.2819 340.204 109.862 342.189 133.04C342.532 137.028 342.413 141.11 341.792 145.194C337.754 171.766 322.676 193.355 304.084 211.546C292.087 223.284 270.475 235.357 254.512 240.229C254.407 240.26 254.296 240.286 254.19 240.328C246.455 243.497 243.232 238.268 248.005 232.138C260.272 216.381 279.267 183.11 255.309 168.273C241.118 159.484 217.639 170.869 203.134 174.789C184.116 179.925 164.056 184.817 144.373 180.654C121.764 175.874 106.43 153.203 109.418 130.159C112.384 107.292 132.781 90.8179 155.555 90.8179H294.513Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.2708 421.176L74.9798 419.784L74.2708 421.176ZM421.176 381.729L422.567 382.438L422.567 382.438L421.176 381.729ZM381.729 421.176L382.438 422.567L382.438 422.567L381.729 421.176ZM421.176 74.2708L419.784 74.9797L421.176 74.2708ZM74.2708 34.8244L73.5618 33.4329L74.2708 34.8244ZM34.8244 74.2708L33.433 73.5618L34.8244 74.2708ZM169.407 26.5479H286.593V23.4247H169.407V26.5479ZM429.452 169.407V286.593H432.575V169.407H429.452ZM286.593 429.452H169.407V432.575H286.593V429.452ZM26.548 286.593V169.407H23.4247V286.593H26.548ZM169.407 429.452C144.105 429.452 125.223 429.451 110.25 428.227C95.2948 427.006 84.3771 424.572 74.9798 419.784L73.5618 422.567C83.4728 427.617 94.8473 430.103 109.995 431.34C125.125 432.577 144.157 432.575 169.407 432.575V429.452ZM23.4247 286.593C23.4247 311.843 23.4235 330.875 24.6596 346.005C25.8973 361.153 28.3831 372.527 33.433 382.438L36.2158 381.02C31.4277 371.623 28.9944 360.705 27.7725 345.75C26.5492 330.777 26.548 311.895 26.548 286.593H23.4247ZM74.9798 419.784C58.2895 411.28 44.7199 397.711 36.2158 381.02L33.433 382.438C42.2365 399.716 56.2839 413.764 73.5618 422.567L74.9798 419.784ZM429.452 286.593C429.452 311.895 429.451 330.777 428.228 345.75C427.006 360.705 424.572 371.623 419.784 381.02L422.567 382.438C427.617 372.527 430.103 361.153 431.34 346.005C432.577 330.875 432.575 311.843 432.575 286.593H429.452ZM286.593 432.575C311.843 432.575 330.875 432.577 346.005 431.34C361.153 430.103 372.527 427.617 382.438 422.567L381.02 419.784C371.623 424.572 360.705 427.006 345.75 428.227C330.777 429.451 311.895 429.452 286.593 429.452V432.575ZM419.784 381.02C411.28 397.711 397.711 411.28 381.02 419.784L382.438 422.567C399.716 413.764 413.764 399.716 422.567 382.438L419.784 381.02ZM286.593 26.5479C311.895 26.5479 330.777 26.5492 345.75 27.7725C360.705 28.9944 371.623 31.4276 381.02 36.2158L382.438 33.4329C372.527 28.383 361.153 25.8973 346.005 24.6596C330.875 23.4234 311.843 23.4247 286.593 23.4247V26.5479ZM432.575 169.407C432.575 144.157 432.577 125.125 431.34 109.995C430.103 94.8473 427.617 83.4728 422.567 73.5618L419.784 74.9797C424.572 84.3771 427.006 95.2947 428.228 110.25C429.451 125.223 429.452 144.105 429.452 169.407H432.575ZM381.02 36.2158C397.711 44.7199 411.28 58.2895 419.784 74.9797L422.567 73.5618C413.764 56.2839 399.716 42.2365 382.438 33.4329L381.02 36.2158ZM169.407 23.4247C144.157 23.4247 125.125 23.4234 109.995 24.6596C94.8473 25.8973 83.4728 28.383 73.5618 33.4329L74.9798 36.2158C84.3771 31.4276 95.2948 28.9944 110.25 27.7725C125.223 26.5492 144.105 26.5479 169.407 26.5479V23.4247ZM26.548 169.407C26.548 144.105 26.5492 125.223 27.7725 110.25C28.9944 95.2947 31.4277 84.3771 36.2158 74.9797L33.433 73.5618C28.3831 83.4728 25.8973 94.8473 24.6596 109.995C23.4235 125.125 23.4247 144.157 23.4247 169.407H26.548ZM73.5618 33.4329C56.2839 42.2365 42.2365 56.2839 33.433 73.5618L36.2158 74.9797C44.7199 58.2895 58.2895 44.7199 74.9798 36.2158L73.5618 33.4329Z",
    fill: "url(#paint2_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M707.529 333.997V294.066H604.669L705.293 157.345V120.929H545.253V160.859H645.877L545.253 297.261V333.997H707.529ZM793.256 337.83C817.214 337.83 841.491 330.483 856.825 316.427L838.616 289.594C828.714 299.177 810.825 304.608 797.728 304.608C771.534 304.608 756.2 288.955 753.325 270.108H868.005V260.525C868.005 210.373 837.019 175.873 790.7 175.873C744.062 175.873 710.84 211.97 710.84 256.692C710.84 306.205 746.298 337.83 793.256 337.83ZM829.033 241.997H753.006C754.603 226.664 765.464 209.095 790.7 209.095C817.533 209.095 827.755 227.303 829.033 241.997ZM920.539 333.997V229.859C927.566 220.914 939.705 211.97 955.677 211.97C972.927 211.97 984.108 219.317 984.108 240.72V333.997H1025V225.067C1025 195.039 1008.7 175.873 974.524 175.873C949.608 175.873 930.441 188.012 920.539 199.512V179.706H879.97V333.997H920.539ZM1142 337.83C1210.04 337.83 1251.25 291.83 1251.25 215.803H1134.97V255.733H1201.42C1194.71 278.094 1176.5 297.58 1146.15 297.58C1107.18 297.58 1079.07 267.872 1079.07 227.622C1079.07 187.373 1107.18 157.665 1146.15 157.665C1168.51 157.665 1186.72 170.442 1196.62 185.456L1234 165.012C1218.03 139.776 1190.23 117.415 1146.15 117.415C1083.54 117.415 1032.43 160.22 1032.43 227.622C1032.43 294.705 1083.54 337.83 1142 337.83ZM1337.44 337.83C1388.55 337.83 1419.22 300.455 1419.22 256.692C1419.22 212.928 1388.55 175.873 1337.44 175.873C1286.65 175.873 1255.98 212.928 1255.98 256.692C1255.98 300.455 1286.65 337.83 1337.44 337.83ZM1337.44 301.733C1312.2 301.733 1298.15 280.969 1298.15 256.692C1298.15 232.734 1312.2 211.97 1337.44 211.97C1362.99 211.97 1377.05 232.734 1377.05 256.692C1377.05 280.969 1362.99 301.733 1337.44 301.733Z",
    fill: "#616670"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 9.36989,
    y: 24.9863,
    width: 437.26,
    height: 454.438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20.3014,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32.7945
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.9589
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.148385 0 0 0 0 0.4625 0 0 0 0 0.440534 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 109.047,
    y: 90.8072,
    width: 237.907,
    height: 275.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.56164
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.56164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.811765 0 0 0 0 0.780392 0 0 0 0.677133 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 228,
    y1: 24.9863,
    x2: 228,
    y2: 423.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999087,
    stopColor: "#E6F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 124.773,
    y1: 100.686,
    x2: 343.27,
    y2: 358.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FF4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CFC7",
    stopOpacity: 0.677133
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 228,
    y1: 24.9863,
    x2: 228,
    y2: 431.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F8F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZengoLogo);
export default __webpack_public_path__ + "static/media/zengo_logo.3c70768c228bf9e9ec46eb77e76e363d.svg";
export { ForwardRef as ReactComponent };